"use client";
import {
  IconDisabledBackwardArrow,
  IconForwardArrow,
} from "@repo/assets/images";
import cx from "classnames";

const CarouselButton = ({
  direction,
  children,
  className,
  variant = "carousel",
  ...restProps
}) => {
  const isPrev = direction === "prev";

  return (
    <button
      className={cx(
        "disabled:border-lightgray group p-2.5 disabled:bg-white",
        {
          "text-lightYellow hover:bg-lightbrown border border-[#DDD9D6]":
            variant === "product",
          "rounded-full": variant === "carousel",
        },
        className
      )}
      type="button"
      aria-label={direction}
      {...restProps}
    >
      <IconForwardArrow
        className={cx({
          "-rotate-180": isPrev,
          "group-disabled:hidden": true,
          "fill-current": variant === "carousel",
        })}
      />
      <IconDisabledBackwardArrow
        className={cx("hidden group-disabled:block", {
          "-rotate-180": !isPrev,
          "fill-current": variant === "carousel",
        })}
      />
      {children}
    </button>
  );
};

export default CarouselButton;
